module.exports = __webpack_public_path__ + "static/img/product1new.1021f166.png";